/* eslint-disable @faire/prefer-arrow-methods */ import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { diag } from "@opentelemetry/api";
import { hrTime } from "@opentelemetry/core";
import { InstrumentationBase } from "@opentelemetry/instrumentation";
var PACKAGE_VERSION = "faire-0.1";
var PACKAGE_NAME = "LongRunningTask";
export var LONGTASK_PERFORMANCE_TYPE = "LongTask";
export var LongTaskInstrumentation = /*#__PURE__*/ function(InstrumentationBase) {
    "use strict";
    _inherits(LongTaskInstrumentation, InstrumentationBase);
    function LongTaskInstrumentation() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, LongTaskInstrumentation);
        var _this;
        _this = _call_super(this, LongTaskInstrumentation, [
            PACKAGE_NAME,
            PACKAGE_VERSION,
            config
        ]);
        _this.version = PACKAGE_VERSION;
        _this._createSpanFromEntry = function(entry) {
            var _this_getConfig = _this.getConfig(), observerCallback = _this_getConfig.observerCallback, onCreateSpan = _this_getConfig.onCreateSpan;
            var span;
            if (onCreateSpan) {
                span = onCreateSpan(hrTime(entry.startTime));
            }
            if (!span) {
                span = _this.tracer.startSpan(LONGTASK_PERFORMANCE_TYPE, {
                    startTime: hrTime(entry.startTime)
                });
            }
            if (observerCallback) {
                try {
                    observerCallback(span, {
                        longtaskEntry: entry
                    });
                } catch (err) {
                    diag.error("longtask instrumentation: observer callback failed", err);
                }
            }
            span.setAttribute("longtask.name", entry.name);
            span.setAttribute("longtask.entry_type", entry.entryType);
            span.setAttribute("longtask.duration", entry.duration);
            if (Array.isArray(entry.attribution)) {
                entry.attribution.forEach(function(attribution, index) {
                    var prefix = entry.attribution.length > 1 ? "longtask.attribution[".concat(index, "]") : "longtask.attribution";
                    span === null || span === void 0 ? void 0 : span.setAttribute("".concat(prefix, ".name"), attribution.name);
                    span === null || span === void 0 ? void 0 : span.setAttribute("".concat(prefix, ".entry_type"), attribution.entryType);
                    span === null || span === void 0 ? void 0 : span.setAttribute("".concat(prefix, ".start_time"), attribution.startTime);
                    span === null || span === void 0 ? void 0 : span.setAttribute("".concat(prefix, ".duration"), attribution.duration);
                    span === null || span === void 0 ? void 0 : span.setAttribute("".concat(prefix, ".container_type"), attribution.containerType);
                    span === null || span === void 0 ? void 0 : span.setAttribute("".concat(prefix, ".container_src"), attribution.containerSrc);
                    span === null || span === void 0 ? void 0 : span.setAttribute("".concat(prefix, ".container_id"), attribution.containerId);
                    span === null || span === void 0 ? void 0 : span.setAttribute("".concat(prefix, ".container_name"), attribution.containerName);
                });
            }
            span.end(hrTime(entry.startTime + entry.duration));
        };
        return _this;
    }
    var _proto = LongTaskInstrumentation.prototype;
    _proto.init = function init() {};
    _proto.isSupported = function isSupported() {
        if (typeof PerformanceObserver === "undefined" || !PerformanceObserver.supportedEntryTypes) {
            return false;
        }
        return PerformanceObserver.supportedEntryTypes.includes(LONGTASK_PERFORMANCE_TYPE);
    };
    _proto.enable = function enable() {
        var _this = this;
        if (!this.isSupported()) {
            this._diag.debug("Environment not supported");
            return;
        }
        if (this._observer) {
            // Already enabled
            return;
        }
        this._observer = new PerformanceObserver(function(list) {
            list.getEntries().forEach(function(entry) {
                return _this._createSpanFromEntry(entry);
            });
        });
        this._observer.observe({
            type: LONGTASK_PERFORMANCE_TYPE,
            buffered: true
        });
    };
    _proto.disable = function disable() {
        if (!this._observer) {
            return;
        }
        this._observer.disconnect();
        this._observer = undefined;
    };
    return LongTaskInstrumentation;
}(InstrumentationBase);
